// Module
var code = `<div ng-if="::examScore" class="exam-score-box"><div class="header" translate-once="lessons.stream.stream_dashboard.exam_score"></div><hr class="hr-hexagon"><p>{{::examScore}}</p></div>`;
// Exports
export default code;